import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider as FelaThemeProvider, ThemeContext } from 'react-fela';
import { useConfig } from '../config/use-config';
import { getTheme } from '../themes/getTheme';
export function ThemePicker(_ref) {
  var direction = _ref.direction,
      variant = _ref.variant,
      children = _ref.children;

  var _useConfig = useConfig(),
      locale = _useConfig.locale;

  var currentTheme = useContext(ThemeContext);
  var theme;

  if (variant) {
    theme = getTheme({
      variant: variant,
      locale: locale,
      direction: direction || (currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.direction)
    });
  } else if (currentTheme) {
    theme = direction ? _objectSpread(_objectSpread({}, currentTheme), {}, {
      direction: direction
    }) : currentTheme;
  } else {
    theme = getTheme({
      variant: 'light',
      locale: locale,
      direction: direction
    });
  }

  return /*#__PURE__*/React.createElement(FelaThemeProvider, {
    theme: theme,
    overwrite: false
  }, children);
}
ThemePicker.propTypes = {
  direction: PropTypes.oneOf(['ltr', 'rtl']),
  variant: PropTypes.oneOf(['light', 'dark']),
  children: PropTypes.node.isRequired
};